import React, { useState, useEffect } from 'react';
import Sidebar from '../mini-comp/Sidebar';
import Topbar from '../mini-comp/Topbar';
import {
  RiBuildingLine, 
  RiUserLine, 
  RiMailLine, 
  RiMessage2Line, 
  RiNotificationLine
} from 'react-icons/ri';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';

const WebsiteAnalytics = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({
    interested_companies: 0,
    interested_candidates: 0,
    subscribers: 0,
    testimonials: 0,
    updates: 0,
    recent_testimonials: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = Cookies.get('token');
        const response = await axios.get('https://inv.burrayhr.com/web/dashboard', {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        const data = response.data;
        console.log(data)
        setDashboardData({
          interested_companies: data.interested_companies_count || data.interested_companies || data.interestedCompanies || 0,
          interested_candidates: data.interested_candidates_count || data.interested_candidates || data.interestedCandidates || 0,
          subscribers: data.subscribers_count || data.subscribers || 0,
          testimonials: data.testimonials_count || data.testimonials || 0,
          updates: data.updates_count || data.updates || 0,
          recent_testimonials: data.recent_testimonials || data.recentTestimonials || []
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching website dashboard data:', error);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <div>
      <Topbar />
      <Sidebar />

      <>{ /* app-content-area-start */ }
      <div className="app-content-area">
        <div className="app-content-wrap">
          <div className="container-fluid">
            
            {/* Header & Quick Navigation */}
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginBottom: '24px', gap: '15px' }}>
              <h4 className="m-0">Website Analytics Dashboard</h4>
              <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
                <button className="btn btn-primary-light btn-sm" onClick={() => navigate('/admin/updates')}>Updates</button>
                <button className="btn btn-success-light btn-sm" onClick={() => navigate('/admin/interested-companies')}>Interested Companies</button>
                <button className="btn btn-info-light btn-sm" onClick={() => navigate('/admin/interested-candidates')}>Interested Candidates</button>
                <button className="btn btn-warning-light btn-sm" onClick={() => navigate('/admin/subscribers')}>Subscribers</button>
                <button className="btn btn-purple-light btn-sm" onClick={() => navigate('/admin/testimonials')}>Testimonials</button>
              </div>
            </div>

            {/* Statistics Cards */}
            <div className="row fix">
              <div className="col-xxl col-xl col-lg-4 col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body mini-card-body d-flex align-center gap-16">
                    <div className="avatar avatar-xl bg-success-transparent text-success">
                      <RiBuildingLine />
                    </div>
                    <div className="card-content">
                      <span className="d-block fs-16 mb-5">Interested Companies</span>
                      <h2 className="mb-0">{loading ? '...' : dashboardData.interested_companies}</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xxl col-xl col-lg-4 col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body mini-card-body d-flex align-center gap-16">
                    <div className="avatar avatar-xl bg-info-transparent text-info">
                      <RiUserLine />
                    </div>
                    <div className="card-content">
                      <span className="d-block fs-16 mb-5">Interested Candidates</span>
                      <h2 className="mb-0">{loading ? '...' : dashboardData.interested_candidates}</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xxl col-xl col-lg-4 col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body mini-card-body d-flex align-center gap-16">
                    <div className="avatar avatar-xl bg-warning-transparent text-warning">
                      <RiMailLine />
                    </div>
                    <div className="card-content">
                      <span className="d-block fs-16 mb-5">Subscribers</span>
                      <h2 className="mb-0">{loading ? '...' : dashboardData.subscribers}</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xxl col-xl col-lg-4 col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body mini-card-body d-flex align-center gap-16">
                    <div className="avatar avatar-xl bg-purple-transparent text-purple">
                      <RiMessage2Line />
                    </div>
                    <div className="card-content">
                      <span className="d-block fs-16 mb-5">Testimonials</span>
                      <h2 className="mb-0">{loading ? '...' : dashboardData.testimonials}</h2>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-xxl col-xl col-lg-4 col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body mini-card-body d-flex align-center gap-16">
                    <div className="avatar avatar-xl bg-primary-transparent text-primary">
                      <RiNotificationLine />
                    </div>
                    <div className="card-content">
                      <span className="d-block fs-16 mb-5">Updates</span>
                      <h2 className="mb-0">{loading ? '...' : dashboardData.updates}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Testimonials */}
            <div className="row" style={{ marginTop: '10px' }}>
              <div className="col-xxl-12 col-xl-12">
                <div className="card">
                  <div className="card-header justify-between">
                    <h4 className="">Recent Testimonials</h4>
                    <Link className="btn btn-primary-light btn-sm text-primary" to="/admin/testimonials">View All</Link>
                  </div>
                  <div className="card-body pt-15">
                    <div className="table-responsive">
                      <table className="table tbody-b-none text-nowrap">
                        <thead>
                          <tr>
                            <th>Name / Company</th>
                            <th>Message</th>
                            <th>Morale</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dashboardData.recent_testimonials && dashboardData.recent_testimonials.length > 0 ? (
                            dashboardData.recent_testimonials.map((testimonial, idx) => (
                              <tr key={testimonial.id || idx}>
                                <td>
                                  <div className="d-flex-items gap-10">
                                    <div className="avatar avatar-xs radius-100">
                                      <img 
                                        className="radius-100" 
                                        src="/assets/images/avatar/avatar-thumb-dummy.png" 
                                        alt={testimonial.name || testimonial.author || 'User'} 
                                      />
                                    </div>
                                    <h6>{testimonial.name || testimonial.author || testimonial.full_name || 'N/A'} {testimonial.company ? `(${testimonial.company})` : ''}</h6>
                                  </div>
                                </td>
                                <td>
                                  <div style={{ maxWidth: '400px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {testimonial.message || testimonial.text || testimonial.content || 'N/A'}
                                  </div>
                                </td>
                                <td>{testimonial.moral}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center py-4">
                                <span className="text-muted">{loading ? 'Loading...' : 'No recent testimonials found'}</span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      { /* app-content-area-end */ }</>
    </div>
  );
};

export default WebsiteAnalytics;